const getTheme = (dark) =>
  dark
    ? {
        pageBg: "rgb(11,15,20)",
        cardBg: "rgba(17,24,39,0.50)",
        cardBorder: "rgba(14,165,233,0.12)",
        cardShadow: "0 2px 8px rgba(0,0,0,0.3)",
        cardHoverBg: "rgba(17,24,39,0.70)",
        cardHoverBorder: "rgba(56,189,248,0.25)",
        cardHoverShadow:
          "0 4px 16px rgba(0,0,0,0.4), 0 0 8px rgba(28,157,234,0.12)",
        divider: "rgba(14,165,233,0.10)",
        pillBg: "rgba(17,24,39,0.60)",
        pillBorder: "rgba(14,165,233,0.12)",
        pillText: "rgba(148,163,184,0.6)",
        pillHoverBg: "rgba(17,24,39,0.80)",
        pillHoverBorder: "rgba(56,189,248,0.25)",
        activeBg: "rgba(14,165,233,0.15)",
        activeBorder: "rgba(14,165,233,0.30)",
        activeText: "rgba(14,165,233,0.9)",
        textPrimary: "rgba(226,232,240,0.9)",
        textSecondary: "rgba(148,163,184,0.7)",
        textMuted: "rgba(148,163,184,0.4)",
        labelBg: "rgba(17,24,39,0.60)",
        labelBorder: "rgba(14,165,233,0.12)",
        labelText: "rgba(148,163,184,0.5)",
        iconBg: "rgba(14,165,233,0.10)",
        iconColor: "rgba(14,165,233,0.85)",
        badgeBg: "rgba(14,165,233,0.10)",
        badgeBorder: "rgba(14,165,233,0.20)",
        badgeText: "rgba(14,165,233,0.85)",
        warnAccent: "rgba(239,68,68,0.6)",
        warnBg: "rgba(239,68,68,0.08)",
        warnIcon: "rgba(248,113,113,0.9)",
        successText: "rgba(52,211,153,0.9)",
      }
    : {
        pageBg: "rgb(255,255,255)",
        cardBg: "rgba(255,255,255,0.9)",
        cardBorder: "rgba(203,213,225,0.5)",
        cardShadow: "0 2px 8px rgba(0,0,0,0.06)",
        cardHoverBg: "rgba(255,255,255,1)",
        cardHoverBorder: "rgba(14,165,233,0.25)",
        cardHoverShadow:
          "0 4px 16px rgba(0,0,0,0.08), 0 0 8px rgba(14,165,233,0.08)",
        divider: "rgba(203,213,225,0.4)",
        pillBg: "rgba(241,245,249,0.8)",
        pillBorder: "rgba(203,213,225,0.4)",
        pillText: "rgba(100,116,139,0.7)",
        pillHoverBg: "rgba(241,245,249,1)",
        pillHoverBorder: "rgba(14,165,233,0.25)",
        activeBg: "rgba(14,165,233,0.10)",
        activeBorder: "rgba(14,165,233,0.30)",
        activeText: "rgba(2,132,199,1)",
        textPrimary: "rgba(15,23,42,0.9)",
        textSecondary: "rgba(71,85,105,0.8)",
        textMuted: "rgba(148,163,184,0.6)",
        labelBg: "rgba(241,245,249,0.8)",
        labelBorder: "rgba(203,213,225,0.4)",
        labelText: "rgba(100,116,139,0.6)",
        iconBg: "rgba(14,165,233,0.08)",
        iconColor: "rgba(2,132,199,0.85)",
        badgeBg: "rgba(14,165,233,0.08)",
        badgeBorder: "rgba(14,165,233,0.20)",
        badgeText: "rgba(2,132,199,0.9)",
        warnAccent: "rgba(220,38,38,0.5)",
        warnBg: "rgba(239,68,68,0.06)",
        warnIcon: "rgba(220,38,38,0.8)",
        successText: "rgba(16,185,129,0.9)",
      };

export default getTheme;
